/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "api/vendors/service.proto" (package "rd.api.vendors", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { VendorsService } from "./service_pb";
import type { DeactivateVendorContactRes } from "./service_pb";
import type { DeactivateVendorContactReq } from "./service_pb";
import type { UpdateVendorContactRes } from "./service_pb";
import type { UpdateVendorContactReq } from "./service_pb";
import type { CreateVendorContactRes } from "./service_pb";
import type { CreateVendorContactReq } from "./service_pb";
import type { ListCatalogVendorIntegrationOptionsRes } from "./service_pb";
import type { ListCatalogVendorIntegrationOptionsReq } from "./service_pb";
import type { UpdateVendorIntegrationRes } from "./service_pb";
import type { UpdateVendorIntegrationReq } from "./service_pb";
import type { ListVendorIntegrationOptionsRes } from "./service_pb";
import type { ListVendorIntegrationOptionsReq } from "./service_pb";
import type { AssignVendorSkusRes } from "./service_pb";
import type { AssignVendorSkusReq } from "./service_pb";
import type { UpdateVendorOrderReceiveSettingsRes } from "./service_pb";
import type { UpdateVendorOrderReceiveSettingsReq } from "./service_pb";
import type { UpdateVendorOrderSettingsRes } from "./service_pb";
import type { UpdateVendorOrderSettingsReq } from "./service_pb";
import type { DuplicateVendorRes } from "./service_pb";
import type { DuplicateVendorReq } from "./service_pb";
import type { ListVendorLocationSettingsOptionsRes } from "./service_pb";
import type { ListVendorLocationSettingsOptionsReq } from "./service_pb";
import type { UpdateVendorSettingsByLocationRes } from "./service_pb";
import type { UpdateVendorSettingsByLocationReq } from "./service_pb";
import type { UpsertVendorBankAccountRes } from "./service_pb";
import type { UpsertVendorBankAccountReq } from "./service_pb";
import type { CreateVendorWithBankAccountRes } from "./service_pb";
import type { CreateVendorWithBankAccountReq } from "./service_pb";
import type { DeleteVendorBankPaymentMethodRes } from "./service_pb";
import type { DeleteVendorBankPaymentMethodReq } from "./service_pb";
import type { SaveVendorBankPaymentMethodRes } from "./service_pb";
import type { SaveVendorBankPaymentMethodReq } from "./service_pb";
import type { GetActiveVendorCountRes } from "./service_pb";
import type { GetActiveVendorCountReq } from "./service_pb";
import type { ListVendorsForCompanyRes } from "./service_pb";
import type { ListVendorsForCompanyReq } from "./service_pb";
import type { GetVendorByIntegrationRes } from "./service_pb";
import type { GetVendorByIntegrationReq } from "./service_pb";
import type { GetVendorRes } from "./service_pb";
import type { GetVendorReq } from "./service_pb";
import type { UpdateVendorIsActiveRes } from "./service_pb";
import type { UpdateVendorIsActiveReq } from "./service_pb";
import type { UpdateVendorNotesRes } from "./service_pb";
import type { UpdateVendorNotesReq } from "./service_pb";
import type { UpdateVendorInformationRes } from "./service_pb";
import type { UpdateVendorInformationReq } from "./service_pb";
import type { BulkUpsertVendorsRes } from "./service_pb";
import type { BulkUpsertVendorsReq } from "./service_pb";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { CreateVendorRes } from "./service_pb";
import type { CreateVendorReq } from "./service_pb";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service rd.api.vendors.VendorsService
 */
export interface IVendorsServiceClient {
    /**
     * Vendor
     *
     * @generated from protobuf rpc: CreateVendor
     */
    createVendor(input: CreateVendorReq, options?: RpcOptions): UnaryCall<CreateVendorReq, CreateVendorRes>;
    /**
     * @generated from protobuf rpc: BulkUpsertVendors
     */
    bulkUpsertVendors(input: BulkUpsertVendorsReq, options?: RpcOptions): UnaryCall<BulkUpsertVendorsReq, BulkUpsertVendorsRes>;
    /**
     * @generated from protobuf rpc: UpdateVendorInformation
     */
    updateVendorInformation(input: UpdateVendorInformationReq, options?: RpcOptions): UnaryCall<UpdateVendorInformationReq, UpdateVendorInformationRes>;
    /**
     * @generated from protobuf rpc: UpdateVendorNotes
     */
    updateVendorNotes(input: UpdateVendorNotesReq, options?: RpcOptions): UnaryCall<UpdateVendorNotesReq, UpdateVendorNotesRes>;
    /**
     * @generated from protobuf rpc: UpdateVendorIsActive
     */
    updateVendorIsActive(input: UpdateVendorIsActiveReq, options?: RpcOptions): UnaryCall<UpdateVendorIsActiveReq, UpdateVendorIsActiveRes>;
    /**
     * @generated from protobuf rpc: GetVendor
     */
    getVendor(input: GetVendorReq, options?: RpcOptions): UnaryCall<GetVendorReq, GetVendorRes>;
    /**
     * @generated from protobuf rpc: GetVendorByIntegration
     */
    getVendorByIntegration(input: GetVendorByIntegrationReq, options?: RpcOptions): UnaryCall<GetVendorByIntegrationReq, GetVendorByIntegrationRes>;
    /**
     * @generated from protobuf rpc: ListVendorsForCompany
     */
    listVendorsForCompany(input: ListVendorsForCompanyReq, options?: RpcOptions): UnaryCall<ListVendorsForCompanyReq, ListVendorsForCompanyRes>;
    /**
     * @generated from protobuf rpc: GetActiveVendorCount
     */
    getActiveVendorCount(input: GetActiveVendorCountReq, options?: RpcOptions): UnaryCall<GetActiveVendorCountReq, GetActiveVendorCountRes>;
    /**
     * @generated from protobuf rpc: SaveVendorBankPaymentMethod
     */
    saveVendorBankPaymentMethod(input: SaveVendorBankPaymentMethodReq, options?: RpcOptions): UnaryCall<SaveVendorBankPaymentMethodReq, SaveVendorBankPaymentMethodRes>;
    /**
     * @generated from protobuf rpc: DeleteVendorBankPaymentMethod
     */
    deleteVendorBankPaymentMethod(input: DeleteVendorBankPaymentMethodReq, options?: RpcOptions): UnaryCall<DeleteVendorBankPaymentMethodReq, DeleteVendorBankPaymentMethodRes>;
    /**
     * @generated from protobuf rpc: CreateVendorWithBankAccount
     */
    createVendorWithBankAccount(input: CreateVendorWithBankAccountReq, options?: RpcOptions): UnaryCall<CreateVendorWithBankAccountReq, CreateVendorWithBankAccountRes>;
    /**
     * @generated from protobuf rpc: UpsertVendorBankAccount
     */
    upsertVendorBankAccount(input: UpsertVendorBankAccountReq, options?: RpcOptions): UnaryCall<UpsertVendorBankAccountReq, UpsertVendorBankAccountRes>;
    /**
     * @generated from protobuf rpc: UpdateVendorSettingsByLocation
     */
    updateVendorSettingsByLocation(input: UpdateVendorSettingsByLocationReq, options?: RpcOptions): UnaryCall<UpdateVendorSettingsByLocationReq, UpdateVendorSettingsByLocationRes>;
    /**
     * @generated from protobuf rpc: ListVendorLocationSettingsOptions
     */
    listVendorLocationSettingsOptions(input: ListVendorLocationSettingsOptionsReq, options?: RpcOptions): UnaryCall<ListVendorLocationSettingsOptionsReq, ListVendorLocationSettingsOptionsRes>;
    /**
     * @generated from protobuf rpc: DuplicateVendor
     */
    duplicateVendor(input: DuplicateVendorReq, options?: RpcOptions): UnaryCall<DuplicateVendorReq, DuplicateVendorRes>;
    /**
     * @generated from protobuf rpc: UpdateVendorOrderSettings
     */
    updateVendorOrderSettings(input: UpdateVendorOrderSettingsReq, options?: RpcOptions): UnaryCall<UpdateVendorOrderSettingsReq, UpdateVendorOrderSettingsRes>;
    /**
     * @generated from protobuf rpc: UpdateVendorOrderReceiveSettings
     */
    updateVendorOrderReceiveSettings(input: UpdateVendorOrderReceiveSettingsReq, options?: RpcOptions): UnaryCall<UpdateVendorOrderReceiveSettingsReq, UpdateVendorOrderReceiveSettingsRes>;
    /**
     * @generated from protobuf rpc: AssignVendorSkus
     */
    assignVendorSkus(input: AssignVendorSkusReq, options?: RpcOptions): UnaryCall<AssignVendorSkusReq, AssignVendorSkusRes>;
    /**
     * @generated from protobuf rpc: ListVendorIntegrationOptions
     */
    listVendorIntegrationOptions(input: ListVendorIntegrationOptionsReq, options?: RpcOptions): UnaryCall<ListVendorIntegrationOptionsReq, ListVendorIntegrationOptionsRes>;
    /**
     * @generated from protobuf rpc: UpdateVendorIntegration
     */
    updateVendorIntegration(input: UpdateVendorIntegrationReq, options?: RpcOptions): UnaryCall<UpdateVendorIntegrationReq, UpdateVendorIntegrationRes>;
    /**
     * @generated from protobuf rpc: ListCatalogVendorIntegrationOptions
     */
    listCatalogVendorIntegrationOptions(input: ListCatalogVendorIntegrationOptionsReq, options?: RpcOptions): UnaryCall<ListCatalogVendorIntegrationOptionsReq, ListCatalogVendorIntegrationOptionsRes>;
    /**
     * Vendor Contact
     *
     * @generated from protobuf rpc: CreateVendorContact
     */
    createVendorContact(input: CreateVendorContactReq, options?: RpcOptions): UnaryCall<CreateVendorContactReq, CreateVendorContactRes>;
    /**
     * @generated from protobuf rpc: UpdateVendorContact
     */
    updateVendorContact(input: UpdateVendorContactReq, options?: RpcOptions): UnaryCall<UpdateVendorContactReq, UpdateVendorContactRes>;
    /**
     * @generated from protobuf rpc: DeactivateVendorContact
     */
    deactivateVendorContact(input: DeactivateVendorContactReq, options?: RpcOptions): UnaryCall<DeactivateVendorContactReq, DeactivateVendorContactRes>;
}
/**
 * @generated from protobuf service rd.api.vendors.VendorsService
 */
export class VendorsServiceClient implements IVendorsServiceClient, ServiceInfo {
    typeName = VendorsService.typeName;
    methods = VendorsService.methods;
    options = VendorsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Vendor
     *
     * @generated from protobuf rpc: CreateVendor
     */
    createVendor(input: CreateVendorReq, options?: RpcOptions): UnaryCall<CreateVendorReq, CreateVendorRes> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateVendorReq, CreateVendorRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BulkUpsertVendors
     */
    bulkUpsertVendors(input: BulkUpsertVendorsReq, options?: RpcOptions): UnaryCall<BulkUpsertVendorsReq, BulkUpsertVendorsRes> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<BulkUpsertVendorsReq, BulkUpsertVendorsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateVendorInformation
     */
    updateVendorInformation(input: UpdateVendorInformationReq, options?: RpcOptions): UnaryCall<UpdateVendorInformationReq, UpdateVendorInformationRes> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateVendorInformationReq, UpdateVendorInformationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateVendorNotes
     */
    updateVendorNotes(input: UpdateVendorNotesReq, options?: RpcOptions): UnaryCall<UpdateVendorNotesReq, UpdateVendorNotesRes> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateVendorNotesReq, UpdateVendorNotesRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateVendorIsActive
     */
    updateVendorIsActive(input: UpdateVendorIsActiveReq, options?: RpcOptions): UnaryCall<UpdateVendorIsActiveReq, UpdateVendorIsActiveRes> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateVendorIsActiveReq, UpdateVendorIsActiveRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetVendor
     */
    getVendor(input: GetVendorReq, options?: RpcOptions): UnaryCall<GetVendorReq, GetVendorRes> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetVendorReq, GetVendorRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetVendorByIntegration
     */
    getVendorByIntegration(input: GetVendorByIntegrationReq, options?: RpcOptions): UnaryCall<GetVendorByIntegrationReq, GetVendorByIntegrationRes> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetVendorByIntegrationReq, GetVendorByIntegrationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListVendorsForCompany
     */
    listVendorsForCompany(input: ListVendorsForCompanyReq, options?: RpcOptions): UnaryCall<ListVendorsForCompanyReq, ListVendorsForCompanyRes> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListVendorsForCompanyReq, ListVendorsForCompanyRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetActiveVendorCount
     */
    getActiveVendorCount(input: GetActiveVendorCountReq, options?: RpcOptions): UnaryCall<GetActiveVendorCountReq, GetActiveVendorCountRes> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetActiveVendorCountReq, GetActiveVendorCountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SaveVendorBankPaymentMethod
     */
    saveVendorBankPaymentMethod(input: SaveVendorBankPaymentMethodReq, options?: RpcOptions): UnaryCall<SaveVendorBankPaymentMethodReq, SaveVendorBankPaymentMethodRes> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<SaveVendorBankPaymentMethodReq, SaveVendorBankPaymentMethodRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteVendorBankPaymentMethod
     */
    deleteVendorBankPaymentMethod(input: DeleteVendorBankPaymentMethodReq, options?: RpcOptions): UnaryCall<DeleteVendorBankPaymentMethodReq, DeleteVendorBankPaymentMethodRes> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteVendorBankPaymentMethodReq, DeleteVendorBankPaymentMethodRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateVendorWithBankAccount
     */
    createVendorWithBankAccount(input: CreateVendorWithBankAccountReq, options?: RpcOptions): UnaryCall<CreateVendorWithBankAccountReq, CreateVendorWithBankAccountRes> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateVendorWithBankAccountReq, CreateVendorWithBankAccountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpsertVendorBankAccount
     */
    upsertVendorBankAccount(input: UpsertVendorBankAccountReq, options?: RpcOptions): UnaryCall<UpsertVendorBankAccountReq, UpsertVendorBankAccountRes> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpsertVendorBankAccountReq, UpsertVendorBankAccountRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateVendorSettingsByLocation
     */
    updateVendorSettingsByLocation(input: UpdateVendorSettingsByLocationReq, options?: RpcOptions): UnaryCall<UpdateVendorSettingsByLocationReq, UpdateVendorSettingsByLocationRes> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateVendorSettingsByLocationReq, UpdateVendorSettingsByLocationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListVendorLocationSettingsOptions
     */
    listVendorLocationSettingsOptions(input: ListVendorLocationSettingsOptionsReq, options?: RpcOptions): UnaryCall<ListVendorLocationSettingsOptionsReq, ListVendorLocationSettingsOptionsRes> {
        const method = this.methods[14], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListVendorLocationSettingsOptionsReq, ListVendorLocationSettingsOptionsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DuplicateVendor
     */
    duplicateVendor(input: DuplicateVendorReq, options?: RpcOptions): UnaryCall<DuplicateVendorReq, DuplicateVendorRes> {
        const method = this.methods[15], opt = this._transport.mergeOptions(options);
        return stackIntercept<DuplicateVendorReq, DuplicateVendorRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateVendorOrderSettings
     */
    updateVendorOrderSettings(input: UpdateVendorOrderSettingsReq, options?: RpcOptions): UnaryCall<UpdateVendorOrderSettingsReq, UpdateVendorOrderSettingsRes> {
        const method = this.methods[16], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateVendorOrderSettingsReq, UpdateVendorOrderSettingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateVendorOrderReceiveSettings
     */
    updateVendorOrderReceiveSettings(input: UpdateVendorOrderReceiveSettingsReq, options?: RpcOptions): UnaryCall<UpdateVendorOrderReceiveSettingsReq, UpdateVendorOrderReceiveSettingsRes> {
        const method = this.methods[17], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateVendorOrderReceiveSettingsReq, UpdateVendorOrderReceiveSettingsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: AssignVendorSkus
     */
    assignVendorSkus(input: AssignVendorSkusReq, options?: RpcOptions): UnaryCall<AssignVendorSkusReq, AssignVendorSkusRes> {
        const method = this.methods[18], opt = this._transport.mergeOptions(options);
        return stackIntercept<AssignVendorSkusReq, AssignVendorSkusRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListVendorIntegrationOptions
     */
    listVendorIntegrationOptions(input: ListVendorIntegrationOptionsReq, options?: RpcOptions): UnaryCall<ListVendorIntegrationOptionsReq, ListVendorIntegrationOptionsRes> {
        const method = this.methods[19], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListVendorIntegrationOptionsReq, ListVendorIntegrationOptionsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateVendorIntegration
     */
    updateVendorIntegration(input: UpdateVendorIntegrationReq, options?: RpcOptions): UnaryCall<UpdateVendorIntegrationReq, UpdateVendorIntegrationRes> {
        const method = this.methods[20], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateVendorIntegrationReq, UpdateVendorIntegrationRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListCatalogVendorIntegrationOptions
     */
    listCatalogVendorIntegrationOptions(input: ListCatalogVendorIntegrationOptionsReq, options?: RpcOptions): UnaryCall<ListCatalogVendorIntegrationOptionsReq, ListCatalogVendorIntegrationOptionsRes> {
        const method = this.methods[21], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListCatalogVendorIntegrationOptionsReq, ListCatalogVendorIntegrationOptionsRes>("unary", this._transport, method, opt, input);
    }
    /**
     * Vendor Contact
     *
     * @generated from protobuf rpc: CreateVendorContact
     */
    createVendorContact(input: CreateVendorContactReq, options?: RpcOptions): UnaryCall<CreateVendorContactReq, CreateVendorContactRes> {
        const method = this.methods[22], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateVendorContactReq, CreateVendorContactRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateVendorContact
     */
    updateVendorContact(input: UpdateVendorContactReq, options?: RpcOptions): UnaryCall<UpdateVendorContactReq, UpdateVendorContactRes> {
        const method = this.methods[23], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateVendorContactReq, UpdateVendorContactRes>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeactivateVendorContact
     */
    deactivateVendorContact(input: DeactivateVendorContactReq, options?: RpcOptions): UnaryCall<DeactivateVendorContactReq, DeactivateVendorContactRes> {
        const method = this.methods[24], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeactivateVendorContactReq, DeactivateVendorContactRes>("unary", this._transport, method, opt, input);
    }
}
